var _linearGradient, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 47,
    viewBox: "0 0 48 47",
    width: 48,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 0.679688,
    x2: 47.5678,
    y1: 23.3543,
    y2: 23.3543
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00adbb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002f87"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m7.07091-.00830078h34.11999c3.5252 0 6.3912 2.85607078 6.3769 6.36903078v33.98717c0 3.513-2.8661 6.3691-6.3913 6.3691h-34.10559c-3.5252 0-6.391222-2.8561-6.391222-6.3691v-33.98717c0-3.51296 2.866022-6.36903078 6.391222-6.36903078zm8.61239 37.97140078c.5445 0 .9888-.4427.9888-.9853v-17.6077c0-.4966-.3721-.9095-.8526-.976-.0455-.0064-.0921-.0098-.1395-.0098h-4.213c-.5446 0-.9888.4427-.9888.9854v17.6076c0 .4966.3721.9095.8526.976.0455.0065.0921.0098.1394.0098zm-6.10462-25.2191c0 2.1992 1.79122 3.9843 3.99812 3.9843.2911 0 .575-.0311.8485-.0901 1.8009-.3875 3.1503-1.9839 3.1503-3.8945 0-2.2004-1.79-3.98417-3.9981-3.98417-1.4815 0-2.7749.80308-3.4656 1.99627-.33912.5853-.53322 1.2643-.53322 1.9882zm28.21592 25.2191c.5016-.0143.9028-.4141.9028-.9139l-.0143.0285v-8.511-.0652c.0002-3.6814.0007-10.2642-7.0174-10.3724-.0635-.0011-.1277-.0016-.1924-.0016-3.2503 0-4.7846 1.1871-5.8163 2.7179v-1.5038c0-.5117-.4116-.9102-.9099-.914-.0024 0-.0048 0-.0072 0h-4.3707c-.5015.0143-.9028.4141-.9028.914v17.7504c0 .492.3888.8871.8794.8994m17.4488-.0283h-4.5283zm-4.5283 0c-.0078 0-.0156-.0001-.0234-.0003zm-.0234-.0003c-.4981-.0039-.8955-.4022-.9098-.8996v-8.2398c0-.0895.0019-.1946.0041-.3126.0269-1.4887.0909-5.0259-3.1603-5.0846-.0219-.0003-.044-.0005-.0663-.0005-2.78 0-3.3532 2.8561-3.4679 4.127v9.525c0 .4998-.4012.8997-.9028.914h-4.3707",
    fill: "url(#a)",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.835e5b9b92977360135bc825c9074766.svg";
export { ForwardRef as ReactComponent };